import React from 'react';
import {ReactReduxContext} from "react-redux";

export default (Component)=>(props)=>
    <ReactReduxContext.Consumer>{({store})=><Component {...props} store={store} />}</ReactReduxContext.Consumer>
